import React from 'react';
import { Modal, DropdownSelector } from 'hyperdb-utils';

class ModalSeasonsConflict extends React.Component {
  constructor(props) {
    super(props);
    this.handleChooseAction = this.handleChooseAction.bind(this);
    this.handleConfirmAction = this.handleConfirmAction.bind(this);
    this.state = {};
  }
  render() {
    return (
      <Modal title="Conflict" onClose={ this.props.close } onAccept={ this.handleConfirmAction }>
        <div className="text-red"><strong>Warning: this season's dates are in conflict with the following seasons:</strong></div>
        <ul>
          {
            this.props.indexesSeasonsInConflict.map(index => {
              const item = this.props.items[index] || {};
              return (<li key={index}><strong>From</strong> { item.date_start } - <strong>To</strong> { item.date_end }</li>);
            })
          }
        </ul>
        <br/>
        <DropdownSelector
          label="What do you want to do ?"
          name="action"
          value={ this.state.actionOnConflict || 0 }
          options={
            [
              { name: 'Back to edit', value: 0 },
              { name: 'Overwrite', value: 1 },
              { name: 'Fill gaps', value: 2 },
            ]
          }
          onChange={ this.handleChooseAction }
        />
      </Modal>
    )
  }
  handleChooseAction(field) {
    const { name, value } = field;
    this.setState({ actionOnConflict: value });
  }
  handleConfirmAction() {
    switch (parseInt(this.state.actionOnConflict)) {
    case 1:
      this.props.overwrite();
      break;
    case 2:
      this.props.fillGaps();
      break;
    default: // Cancel
    }
    this.props.close();
  }
}

export default ModalSeasonsConflict;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/ModalSeasonsConflict.jsx